const FeGroupLogicValidation = {
    initialize: function () {
        console.log('Initialisierung gestartet');

        // Füge globale Validierungsfunktion hinzu
        this.registerValidationHandler();

        // MutationObserver zum Überwachen des Iframes
        this.observeDomChangesForIframe();

        // Fallback: Suche regelmäßig nach dem Iframe, falls MutationObserver es nicht findet
        const interval = setInterval(() => {
            const iframe = document.querySelector('iframe.t3js-scaffold-content-module-iframe') as HTMLIFrameElement;

            if (iframe) {
                console.log('Iframe durch Polling gefunden:', iframe);
                clearInterval(interval); // Stoppe die Suche, wenn das Iframe gefunden wurde
                this.initializeIframe(iframe);
            }
        }, 500); // Überprüfung alle 500ms
    },

    registerValidationHandler: function () {
        console.log('Registriere Validierung für Speichern.');

        // TYPO3 Client-Side Validation API verwenden
        document.addEventListener('typo3:validation:before-save', (event: Event) => {
            const invalidFields = this.validateFieldsBeforeSave();
            if (invalidFields.length > 0) {
                console.error('Es gibt ungültige Felder. Verhindere Speichern.');
                event.preventDefault(); // Verhindert das Speichern
                this.showGlobalErrorMessage(invalidFields);
            }
        });
    },

    validateFieldsBeforeSave: function (): HTMLInputElement[] {
        console.log('Überprüfe Felder vor dem Speichern.');
        const invalidFields: HTMLInputElement[] = [];
        const fieldsToValidate = document.querySelectorAll('input[data-fegroup-logic-eval="true"]') as NodeListOf<HTMLInputElement>;

        fieldsToValidate.forEach((field) => {
            const value = field.value.trim();
            if (value.length > 0 && !this.isValidExpression(value)) {
                console.log('Ungültiger Ausdruck gefunden:', field);
                invalidFields.push(field);
            }
        });

        return invalidFields;
    },

    isValidExpression: function (value: string): boolean {
        // Überprüfe hier die Validierung (diese sollte dieselbe Logik wie der Server haben)
        const regex = /^[\d\s()ANDOR]+$/; // Beispiel: Einfache Logikprüfung
        return regex.test(value);
    },

    showGlobalErrorMessage: function (fields: HTMLInputElement[]) {
        console.error('Globale Fehlermeldung anzeigen.');
        fields.forEach((field) => {
            this.showError(field, 'Der Ausdruck ist ungültig. Bitte korrigieren.');
        });
    },

    observeDomChangesForIframe: function () {
        console.log('MutationObserver für Iframe gestartet');
        const targetNode = document.querySelector('.scaffold-content-module') as HTMLElement;

        if (!targetNode) {
            console.error('Container für das Iframe nicht gefunden');
            return;
        }

        const config = { childList: true, subtree: true };

        const observer = new MutationObserver(() => {
            const iframe = document.querySelector('iframe.t3js-scaffold-content-module-iframe') as HTMLIFrameElement;

            if (iframe) {
                console.log('Iframe durch MutationObserver gefunden:', iframe);
                observer.disconnect(); // Beobachtung stoppen, sobald das Iframe gefunden wurde
                this.initializeIframe(iframe);
            }
        });

        observer.observe(targetNode, config);
    },

    initializeIframe: function (iframe: HTMLIFrameElement) {
        iframe.addEventListener('load', () => {
            console.log('Iframe geladen');
            const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

            if (iframeDocument) {
                console.log('Zugriff auf Iframe-Dokument erfolgreich');
                this.observeIframeDomChanges(iframeDocument);

                // Fallback: Überprüfe regelmäßig, ob Felder im iframe verfügbar sind
                const fieldInterval = setInterval(() => {
                    const fieldsToValidate = iframeDocument.querySelectorAll('input[data-fegroup-logic-eval="true"]') as NodeListOf<HTMLInputElement>;
                    if (fieldsToValidate.length > 0) {
                        console.log('Felder im Iframe durch Polling gefunden:', fieldsToValidate);
                        clearInterval(fieldInterval); // Stoppe das Polling, wenn Felder gefunden wurden
                        this.initializeValidation(fieldsToValidate);
                    }
                }, 500); // Überprüfung alle 500ms
            } else {
                console.error('Kein Zugriff auf das Iframe-Dokument möglich');
            }
        });
    },

    observeIframeDomChanges: function (iframeDocument: Document) {
        console.log('MutationObserver im Iframe gestartet');
        const targetNode = iframeDocument.body;
        const config = { childList: true, subtree: true };

        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node instanceof HTMLElement) {
                            const inputFields = node.matches('input[data-fegroup-logic-eval="true"]')
                                ? [node] as unknown as NodeListOf<HTMLInputElement>
                                : node.querySelectorAll('input[data-fegroup-logic-eval="true"]') as NodeListOf<HTMLInputElement>;

                            if (inputFields.length > 0) {
                                console.log('Neue Felder im Iframe gefunden:', inputFields);
                                this.initializeValidation(inputFields);
                            }
                        }
                    });
                }
            });
        });

        observer.observe(targetNode, config);
    },

    initializeValidation: function (fields: NodeListOf<HTMLInputElement>) {
        console.log('Initialisiere Validierung für folgende Felder:', fields);

        fields.forEach((inputField) => {
            console.log('Event-Listener wird hinzugefügt für:', inputField);

            inputField.addEventListener('input', (e) => {
                console.log('Eingabe erkannt:', (e.target as HTMLInputElement).value);

                // Entferne die Info-Nachricht bei Eingabe
                this.clearInfo(inputField);

                // Führe die Validierung durch
                this.validateField(inputField, (e.target as HTMLInputElement).value);
            });
        });
    },

    async validateField(inputField: HTMLInputElement, value: string) {
        console.log('Validierung gestartet für Wert:', value);

        const trimmedValue = value.trim();
        const ajaxUrl = '/ajax/validateFeGroupLogic';

        // Wenn das Feld leer ist, zeige eine Info-Nachricht an und entferne eventuelle Fehlermeldungen
        if (trimmedValue.length === 0) {
            console.log('Feld ist leer, das ist erlaubt. Zeige Info-Nachricht an.');
            this.clearError(inputField); // Bestehende Fehler entfernen
            this.showInfo(inputField, 'Eingabe ist optional.');
            return; // Keine weitere Validierung erforderlich
        }

        try {
            console.log(`Sende AJAX-Request: ${ajaxUrl}, Wert: ${trimmedValue}`);
            const response = await fetch(`${ajaxUrl}?value=${encodeURIComponent(trimmedValue)}`);
            const data = await response.json();
            console.log('AJAX-Response:', data);

            if (data.valid) {
                console.log('Wert ist gültig.');
                this.clearError(inputField);
                this.showInfo(inputField, 'Der Ausdruck ist gültig.');
            } else {
                console.log('Wert ist ungültig.');
                this.showError(inputField, 'Ungültiger Wert.');
            }
        } catch (error) {
            console.error('Fehler bei der Validierung:', error);
            this.showError(inputField, 'Ein Fehler ist aufgetreten.');
        }
    },

    showError: function (inputField: HTMLInputElement, message: string) {
        console.log('Zeige Fehlermeldung an:', message);
        if (!inputField.classList.contains('is-invalid')) {
            inputField.classList.add('is-invalid');
        }

        let errorContainer = inputField.closest('.form-group')?.querySelector('.error-message');
        if (!errorContainer) {
            errorContainer = document.createElement('div');
            errorContainer.className = 'error-message text-danger';
            inputField.closest('.form-group')?.appendChild(errorContainer);
        }
        errorContainer.textContent = message;
    },

    clearError: function (inputField: HTMLInputElement) {
        console.log('Entferne Fehlermeldung');
        inputField.classList.remove('is-invalid');
        const errorContainer = inputField.closest('.form-group')?.querySelector('.error-message');
        if (errorContainer) {
            errorContainer.remove();
        }
    },

    showInfo: function (inputField: HTMLInputElement, message: string) {
        console.log('Zeige Info-Nachricht an:', message);
        let infoContainer = inputField.closest('.form-group')?.querySelector('.info-message');
        if (!infoContainer) {
            infoContainer = document.createElement('div');
            infoContainer.className = 'info-message text-info';
            inputField.closest('.form-group')?.appendChild(infoContainer);
        }
        infoContainer.textContent = message;
    },

    clearInfo: function (inputField: HTMLInputElement) {
        console.log('Entferne Info-Nachricht');
        const infoContainer = inputField.closest('.form-group')?.querySelector('.info-message');
        if (infoContainer) {
            infoContainer.remove();
        }
    },
};

export default FeGroupLogicValidation;
